<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div class="trans-bank" v-show="loaded" style="margin-top: 1px">
      <div class="row bg-white trans-summary" @click="toTransAccounts">
        <div>
          <div class="summary" style="padding: 12px 12px 6px 16px">
            应付金额
            <label class="money">￥{{ orderInfo.to_pay_amount }}</label>
          </div>
        </div>
      </div>
      <div class="row bg-white trans-summary" @click="toTransAccounts">
        <div>
          <div class="summary" style="padding: 6px 12px 12px 16px">
            <span style="display: inline-block; letter-spacing: 5px; margin-right: -5px;">已转账</span>
            <label class="money">￥{{ orderInfo.paid_price }}</label>
          </div>
          <div class="arrow-detail arrow" style="float: none;">
            <span class="ic-arrow-yellow" style="margin: 6px 0 12px 0"></span>
          </div>
        </div>
      </div>

      <div class="row" v-show="showAction" style="height: 42px">
        <div class="form-header">
					<span class="ic-info"></span>
          <span style="margin-left: 4px; font-size: 13px">请确认如下查账记录是否正确</span>
        </div>
      </div>

      <div class="row" v-show="showAction">
        <div>
          <order-pay-item
            v-for="(item, index) in transList"
            :key="item.payment_id"
            :payment="item"
            :last="index === transList.length-1"
            role="customer"
          ></order-pay-item>
        </div>
      </div>

			<div class="fixed-bottom">
				<div v-if="orderInfo.is_confirm_enabled" style="display: flex; padding: 16px 20px; gap: 20px">
					<BottomButton title="提交" @click="onSubmitClick"/>
				</div>

				<div v-else style="display: flex; padding: 16px 20px; gap: 20px">
					<BottomButton
						v-if="paymentBeforeSubmitCount > 0"
						title="先提交审核"
						:subtitle="`(共${paymentBeforeSubmitCount}笔待提交)`"
						type="secondary"
						width="40%"
						@click="handleSubmitAudit"
					/>

					<BottomButton
						title="继续录入"
						:subtitle="`（还差${amountRemain}元）`"
						type="primary"
						@click="onSubmitClick"
					/>
				</div>
			</div>

			<div>
				<ConfirmPopUp
					:visible="isShowConfirmPopup"
					:content="confirmPopupUsingConfig.content"
					:confirmText="confirmPopupUsingConfig.confirmText"
					:showCancel="confirmPopupUsingConfig.showCancel"
					@confirm="confirmPopupUsingConfig.onConfirm"
					@cancel="isShowConfirmPopup = false"
				/>
			</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Button, MessageBox } from "mint-ui";
import OrderPayItem from "@/components/OrderPayItem";
import BottomButton from "../../components/BottomButton.vue";
import ConfirmPopUp from "../../components/ConfirmPopUp.vue";

export default {
  name: "TransList",
  data: () => ({
    showAction: false,
    showButton: true,
    loaded: false,
    canSubmit: false,
    btn_title: "提交",

		isShowConfirmPopup: false,
		confirmPopupConfigIndex: 0,
		pollTimer: null
  }),
  computed: {
    ...mapGetters({
      role: "getRole",
      orderInfo: "getOrder",
      transList: "getTransList",
      payway: "getSelectedPayway"
    }),
		amountRemain() {
			if (this.orderInfo.amount_remain === undefined) {
				return 0
			}
			return this.orderInfo.amount_remain
		},
		paymentBeforeSubmitCount() {
			if (!Array.isArray(this.transList)) {
				return 0;
			}
			return this.transList.filter(item => item.pay_status === 11).length // 待提交的查账记录个数
		},
		paymentInvalidCount() {
			if (!Array.isArray(this.transList)) {
				return 0;
			}
			return this.transList.filter(item => item.pay_status === 70).length // 审核拒绝的查账记录个数
		},
		confirmPopupUsingConfig() {
			switch (this.confirmPopupConfigIndex) {
				case 0:
					return {
						content: `您还差${this.amountRemain}元才达到应付金额，确认要不再录入，先提交审核？`,
						confirmText: '确认提交',
						showCancel: true,
						onConfirm: this.syncTransPayment
					};
				case 1:
					return {
						content: `您有${this.paymentInvalidCount}笔“审核拒绝”的查账记录，请修改后再提交。`,
						confirmText: '我知道了',
						showCancel: false,
						onConfirm: () => {
							this.isShowConfirmPopup = false
						}
					};
				default:
					return {
						content: `出错！`,
						confirmText: '确认',
						showCancel: false,
						onConfirm: () => {
							this.isShowConfirmPopup = false
						}
					};
			}
		}
  },
  components: {
		ConfirmPopUp,
		BottomButton: BottomButton,
    OrderPayItem,
    "mt-button": Button
  },
  mounted: function() {
    this.setPageTitle("查账信息登记");
    this.loadOrderDetail();
    this.startPolling();
  },
  beforeRouteLeave(to, from, next) {
    this.stopPolling();
    next();
  },
  beforeDestroy: function() {
    this.stopPolling();
  },
  methods: {
    startPolling() {
      this.pollTimer = setInterval(() => {
        this.loadPayments(true);
      }, 5000);
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    onSubmitClick() {
			if (this.paymentInvalidCount > 0) {
				this.confirmPopupConfigIndex = 1
				this.isShowConfirmPopup = true
				return
			}
      if (this.orderInfo.has_paid === false) {
        // this.toast('订单还没付完款，请继续转账')
        this.toTransAccounts();
        return;
      }
      MessageBox.confirm(
        "请确认您录入的转账信息是否完全正确，提交后不允许修改"
      ).then(
        action => {
          console.log(action);
          if (action === "confirm") {
            this.transConfirm();
          }
        },
        action => {}
      );
    },
    toTransAccounts() {
      if (this.showButton) {
        this.$router.push("/trans/accounts");
      }
    },
    loadOrderDetail(isIgnoreCache = false) {
      if (!isIgnoreCache) {
        if (this.orderInfo && this.orderInfo.paid_price) {
          this.loadPayments();
          return;
        }
      }
      this.getOrderSimpleDetail(this.$route.params.id, rs => {
        this.loadPayments(isIgnoreCache);
      });
    },
    setEleAction() {
      this.showAction = this.transList.length > 0;
      this.showButton =
        this.orderInfo.pay_status !== 60 && this.orderInfo.pay_status !== 30;
      if (this.orderInfo.has_paid === true) {
        this.btn_title = "提交";
      } else {
        this.btn_title = "转账金额不足，请继续录入";
      }
      if (
        this.orderInfo.pay_status === 60 &&
        this.orderInfo.survey_code.length === 0
      ) {
        this.showSurveyNotes();
      }
      this.loaded = true;
    },
    showSurveyNotes() {
      MessageBox.alert(
        "您的客户还未做《投资者风险承受能力问卷》, 请现在引导您的客户使用订单分享链接去完成问卷"
      ).then(action => {});
    },
    loadPayments(force = false) {
      if (!force && this.transList.length > 0) {
        this.setEleAction();
        return;
      }
      let url = "/api/orders/payments/" + this.orderInfo.order_id;
      this.$http.get(url).then(
        response => {
          var rs = response.body;
          if (rs.code === 0) {
            this.$store.dispatch("setTransList", { items: rs.data });
            // this.transList = rs.data
            if (rs.data.length === 0) {
              if (this.payway && this.payway.routeCode) {
                this.$router.push("/trans/accounts");
              }
            }
            this.setEleAction();
          } else {
            this.handleHttpError(response);
          }
        },
        response => {
          console.log(response);
          this.handleHttpError(response);
        }
      );
    },
    transConfirm() {
      let url = "/api/orders/payments/trans/confirm/" + this.orderInfo.order_no;
      this.loading("正在提交...");
      this.$http.post(url).then(
        response => {
          console.log(response);
          this.loadingHide();
          var rs = response.body;
          if (rs.code === 0) {
            if (rs.data.has_paid === true) {
              this.showButton = false;
              if (this.role === "customer") {
                if (rs.data.action === "TransList") {
                  this.$router.go();
                  return;
                }
                this.$router.replace({
                  name: rs.data.action,
                  params: { id: this.orderInfo.order_no }
                });
                // this.$router.replace('/orders/pay/success/' + this.orderInfo.order_no)
                // this.$router.replace('/orders/verify/' + this.orderInfo.order_no)
              } else {
                this.$router.replace("/orders/" + this.orderInfo.order_no);
              }
            } else {
              this.toast(rs.message);
            }
          } else if (rs.code === 10702) {
            this.$router.replace("/orders/" + this.orderInfo.order_no);
            this.showSurveyNotes();
          } else {
            this.handleHttpError(response, true);
          }
        },
        response => {
          console.log(response);
          this.handleHttpError(response);
        }
      );
    },
		handleSubmitAudit() {
			// 先提交部分查账记录进行审核
			if (this.paymentBeforeSubmitCount === 0) {
				return
			}
			if (this.paymentInvalidCount > 0) {
				this.confirmPopupConfigIndex = 1
				this.isShowConfirmPopup = true
				return
			}
			this.confirmPopupConfigIndex = 0
			this.isShowConfirmPopup = true
		},
		syncTransPayment() {
			this.isShowConfirmPopup = false
			const url = '/api/payments/sync'
			this.loading("正在提交...");
			this.$http.post(url, {
				'order_no': this.orderInfo.order_no
			}).then(
				response => {
					this.loadingHide();
					if (response.body.code === 0) {
						this.toast('提交成功')
						this.loadOrderDetail(true)
					} else {
						this.handleHttpError(response, true)
					}
				},
				response => {
					console.log(response);
					this.handleHttpError(response);
				}
			);
		}
  }
};
</script>

<style scoped>
.fixed-bottom {
	position: fixed;
	bottom: 0;
	right: 0;
	left: 0;
	height: 81px;

	background: #fff;
	box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5), 0 -1px 4px 0 rgba(0,0,0,0.08);
	z-index: 1000;
}

body {
	padding-bottom: 81px;
}
</style>



// WEBPACK FOOTER //
// src/views/payment/TransList.vue